import React from 'react';
import styled, { css } from 'styled-components';

type BadgeVariant = 'active' | 'lost' | 'towin' | 'new' | 'default';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  dot?: boolean;
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  children,
  dot = true
}) => {
  return (
    <BadgeEl $variant={variant}>
      {dot && <Dot />}
      {children}
    </BadgeEl>
  );
};

const variantStyles: Record<BadgeVariant, string> = {
  active: 'background: var(--olive-soft); color: var(--olive);',
  lost: 'background: var(--crimson-soft); color: var(--crimson);',
  towin: 'background: var(--amber-soft); color: var(--amber);',
  new: 'background: var(--terracotta-soft); color: var(--terracotta-dark);',
  default: 'background: var(--paper); color: var(--ink-muted);'
};

const BadgeEl = styled.span<{ $variant: BadgeVariant }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: var(--radius-pill);
  font-size: 11.5px;
  font-weight: 500;
  line-height: 1.4;
  white-space: nowrap;
  ${({ $variant }) => variantStyles[$variant]}
`;

const Dot = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
`;
